import type { ProcessingDataMetadataAggregate } from '@avisoma/shared/dist/ProcessingData';
import { CollapsibleCard } from './CollapsibleCard';

const COLLAPSIBLE_STORAGE_KEY = 'documentView.collapsible.documentMetadata';

export function DocumentMetadataDetails({ metadata }: { metadata: ProcessingDataMetadataAggregate | undefined }) {
  if (!metadata) {
    return <></>;
  }

  return (
    <CollapsibleCard storageKey={COLLAPSIBLE_STORAGE_KEY} title="Document metadata">
      <div className="divide-y divide-gray-100 dark:divide-zinc-700/50">
        {metadata.esns && (
          <MetadataRow label="ESNs">
            {metadata.esns.map((esn, index) => (
              <Tag key={index} variant="blue">
                {esn}
              </Tag>
            ))}
          </MetadataRow>
        )}
      </div>
    </CollapsibleCard>
  );
}

const TAG_VARIANTS = {
  neutral:
    'bg-gray-100 text-gray-700 dark:bg-zinc-700/60 dark:text-zinc-300',
  amber:
    'bg-amber-50 text-amber-700 ring-1 ring-amber-200/60 dark:bg-amber-900/30 dark:text-amber-300 dark:ring-amber-700/40',
  blue:
    'bg-sky-50 text-sky-700 ring-1 ring-sky-200/60 dark:bg-sky-900/30 dark:text-sky-300 dark:ring-sky-700/40',
} as const;

function Tag({ children, variant }: { children: React.ReactNode; variant: keyof typeof TAG_VARIANTS }) {
  return (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ${TAG_VARIANTS[variant]}`}>
      {children}
    </span>
  );
}

function MetadataRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex items-baseline gap-3 py-2 first:pt-0 last:pb-0">
      <span className="shrink-0 w-12 text-[11px] font-medium uppercase tracking-wider text-gray-400 dark:text-zinc-500">
        {label}
      </span>
      <div className="flex flex-wrap gap-1.5 max-h-[200px] overflow-auto">
        {children}
      </div>
    </div>
  );
}
